import { createApp } from "vue";
import VueGtag from "vue-gtag-next";

import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import "./assets/tailwind.css";
import "@iconscout/unicons/css/line.css";
import "@iconscout/unicons/css/solid.css";
import i18n from "./i18n";
import ClickOutside from "@/directives/ClickOutside";
import VueSignaturePad from "vue-signature-pad";
import { initSentry } from "@/plugins/sentry";

const app = createApp(App);

// Debe inicializarse antes de montar la app para capturar errores de arranque
initSentry(app, router);

app.use(i18n);
app.use(router);
app.use(VueSignaturePad);
app.use(ClickOutside);
app.use(VueGtag, {
  property: {
    id: "G-QV4ZKR35DT",
  },
});

router.isReady().then(() => {
  app.mount("#app");
});
